<template lang="pug">
.v-atms.atms(v-if="data" :id="data?.id")
	.atms__head
		.container
			.atms__title(v-if="data.title") {{data.title}}
			.atms__actions
				.atms__action(v-if="data.fields" )
					v-filter(:filter="{...data,  title: data.filterText, closeText: data.closeText, view}" :action="formAction" :open-state="openFilterState" @open-state-change="state => openFilterState = state" @filter-updated="handlerFilterUpdated")
				.atms__action
					.atms__map-action-area(v-if="isTablet" :style="{backgroundImage: data.mapPlaceholder ? `url(${data.mapPlaceholder})` : null}")
						button.btn.atms__map-action(type="button" @click="handlerMobPanelState(true, 'map')") {{data.mapMobText}}
					v-field-tabs(v-else="" :field="{options: [{'text': data.listText, value: 'list', svg: 'graphic-news-light'},{'text': data.mapText, value: 'map', svg: 'graphic-point-light-2'}]}" :model-value="view" @update:model-value="handlerChangeView")
				.atms__action(v-if="!isTablet && filterCount")
					button.filter-clear-btn(type="button" @click="handlerClearFilter")
						v-svg-icon.filter-clear-btn__icon(icon="graphic-trash")
						span.filter-clear-btn__note(v-if="data.buttons?.clear?.text") {{data.buttons.clear.text}}
	.container(v-if="data.message")
		.atms__message {{data.message.title || data.message.text}}
	template(v-else="")
		.atms__map-area(v-if="view === 'map' || isTablet")
			template(v-if="isTablet")
				teleport(to="body")
					.atms__map-panel(v-if="openMobMap")
						.atms__map-panel-actions
							.atms__map-panel-filter
								button.btn.btn--stroke(type="button" @click="openFilterState = true")
									v-svg-icon.btn__icon(icon="graphic-filter")
									| {{data.filterText}}
							button.atms__map-panel-close(type="button" @click="handlerMobPanelState(false, 'list')")
								v-svg-icon.atms__map-panel-close-icon(icon="cross")
						v-map(v-if="data.map" :items="items" :api-key="data.map.apiKey" @showPoint="handlerShowPoint" :key="items")
			template(v-else="")
				v-map(v-if="data.map" :items="items" :api-key="data.map.apiKey" @showPoint="handlerShowPoint" :key="items")
			v-panel(v-if="isTablet" :open-state="!!active" body-class="atms__map-panel-content" @close="active = null" :close-text="data.closeText")
				template(#content)
					v-atm-card(:card="active")
			template(v-else="")
				transition(name="fade")
					.atms__map-card(v-if="active")
						button.atms__map-card-close(type="button" @click="active = null")
							v-svg-icon.atms__map-card-close-icon(icon="cross")
						v-atm-card(:card="active")
		.atms__main(v-if="view === 'list' || isTablet")
			.container.atms__main-container
				.atms__items(v-if="items")
					.atms__item(v-for="item in items")
						v-atm-card(:card="item")
				.atms__pagination(v-if="data.page")
					v-page-nav(:page="data.page" @navigate="navigate")
				.atms__links_after_pagination(v-if="data.linksAfterPagination")
					a.atm-card__text(v-for="link in data.linksAfterPagination" :href="link.href"  ) {{link.title}}


</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			view: 'list',
			items: null,
			active: null,
			openMobMap: false,
			formAction: null,
			openFilterState: false,
			filterCount: null
		}
	},

	methods: {
		dataSet(data, options = {}) {
			this.updateLocalData(data, options);
		},

		handlerShowPoint(item) {
			this.active = item;
		},

		handlerChangeView(value) {
			this.view = value;
		},

		handlerClearFilter() {
			this.formAction = 'clear';
			setTimeout(() => this.formAction = null, 0);
		},

		handlerFilterUpdated(res, options = {}) {
			this.updateLocalData(res, options);
		},

		updateLocalData(data, options) {
			this.data = data;
			this.items = data.items;
			this.filterCount = data.filterCount;
			this.active = null;
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}
		},

		navigate(page) {
			this.data.page.offset = page.offset;
			this.data.page.limit = page.limit;
			this.formAction = 'navigate';
			setTimeout(() => this.formAction = null, 0);
		},

		handlerMobPanelState(state, view) {
			this.openMobMap = state;
			this.handlerChangeView(view);
		}
	}
}

</script>